import i18nFactory from '@yandex-int/i18n';

import { OutputCategory } from '../../typings/graphql-log';

import * as keyset from './SimpleMultipliersHelpers.i18n';

const i18n = i18nFactory(keyset);

export class SimpleMultipliersHelpers {
    static getSimpleMultiplier(category: OutputCategory): string {
        switch (category) {
            case OutputCategory.CAMPAIGN_MOBILE_MULTIPLIER:
            case OutputCategory.ADGROUP_MOBILE_MULTIPLIER:
                return i18n('on-condition-mobile');
            case OutputCategory.CAMPAIGN_VIDEO_MULTIPLIER:
            case OutputCategory.ADGROUP_VIDEO_MULTIPLIER:
                return i18n('on-condition-video');
            case OutputCategory.CAMPAIGN_PERFORMANCE_TGO_MULTIPLIER:
            case OutputCategory.ADGROUP_PERFORMANCE_TGO_MULTIPLIER:
                return i18n('on-condition-perfomance');
            default:
                throw Error(`Не поддерживается корректировка типа ${category}`);
        }
    }
}
